import gql from 'graphql-tag';

const query = gql`
  query searchPlaces(
    $searchTerm: String!
    $country: String
    $types: [String!]
    $tripId: String
    $emailId: String
  ) {
    searchPlaces(
      term: $searchTerm
      types: $types
      country: $country
      tripId: $tripId
      emailId: $emailId
    ) {
      language
      placeName
      mbId
      placeType
      placeContext {
        id
        mapbox_id
        wikidata
        short_code
        text_en
        language_en
        text
        language
      }
      center
      relevance
      text
    }
  }
`;

export default function searchPlaces({
  apollo,
  searchTerm,
  country,
  types = ['district', 'place', 'locality', 'poi'],
  tripId,
  emailId
}) {
  return apollo.query({
    query,
    variables: {
      searchTerm,
      country,
      types,
      tripId,
      emailId
    }
  });
}
